import type { AuthAdapter } from '@upme/api-client';

export interface MemoryAccessAdapter extends AuthAdapter {
  onRefreshFailHandler?: () => void;
}

export function createMemoryAccessAdapter(): MemoryAccessAdapter {
  let access: string | undefined;
  const adapter: MemoryAccessAdapter = {
    getAccess: () => access,
    setAccess: (t) => {
      access = t;
    },
    onRefreshFail: () => {
      access = undefined;
      adapter.onRefreshFailHandler?.();
    },
    clear: () => {
      access = undefined;
    },
  };
  return adapter;
}

// App-wide singleton — used by api-client and AuthProvider
export const authAdapter = createMemoryAccessAdapter();
